import * as Highcharts from "highcharts";

export const barChartConfig = {
    chart: {
        type: 'column',
        oneToOne: true,
        accessibility: {
          enabled: true
        }
    },
    title: {
        text: (null as any)
    },
    credits: {
        enabled: false
    },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#ff0000'
        }
    },
    xAxis: {
        type: 'linear',
        title: {
            text: undefined
        },
        categories: []
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    legend: {
        enabled: true, 
        align: 'center',
        verticalAlign: 'middle',
    },
    series: [],
    plotOptions: {
        column: {
            colorByPoint: false,
            dataLabels: {
                rotation: -90,
                enabled: true,
                style: {
                    color: '#333', 
                    fontSize: '9px' ,
                },
                y: -12,
                formatter: function() {
                    let value = this.y;
                    if (Math.abs(value) >= 1000000000) {
                        return (value / 1000000000).toFixed(1) + 'B';
                    } else if (Math.abs(value) >= 1000000) {
                        return (value / 1000000).toFixed(1) + 'M';
                    } else if (Math.abs(value) >= 1000) {
                        return (value / 1000).toFixed(1) + 'K';
                    } else {
                        return value;
                    }
                },
                distance: 0 
            },
            pointPadding: 0.1,
            groupPadding: 0.1 
            
        }
    }
};

export const lineChartConfig = {
    chart: {
        type: 'line',
        accessibility: {
          enabled: true
        }
    },
    title: {
        text: (null as any)
    },
    credits: {
        enabled: false
    },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#ff0000'
        }
    },
    xAxis: {
        type: 'linear',
        title: {
            text: undefined
        },
        categories: []
    },
    yAxis: {
        title: {
            text: 'Count',
        }
    },
    legend: {
        enabled: true, 
        align: 'center',
        verticalAlign: 'middle',
    },
    series: []
};

export const pieChartConfig = {
  chart: {
      type: 'pie',
      accessibility: {
        enabled: false
      }
  },
  title: {
      text: (null as any)
  },
  credits: {
      enabled: false
  },
  noData: {
      style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#ff0000'
      }
  },
  xAxis: {
      visible: true
  },
  yAxis: {
      visible: true
  },
  legend: {
      enabled: true, 
      align: 'center',
      verticalAlign: 'bottom',
  },
  plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: false,
              format: '<b>{point.name}</b>: {point.y}',
              style: {
                  color: (Highcharts.theme) || 'black'
              }
          },
          showInLegend: true,
      }
  },
  series: []
};
export const stackBarChartConfig = {
    credits: {
        enabled: false
    },
    chart: {
        type: 'column',
    },
    title: {
        text: null
    },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#ff0000'
        }
    },
    xAxis: {
        title: {
            text: null
        },
        categories: []
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Y-Axis'
        },
        stackLabels: {
            enabled: false,
            rotation: -90,
            y: -8,
            inside: true ,
            style: {
                color: '#333', 
                fontSize: '9px' ,
            },
            formatter: function() :string{
                let value = (this as any).total;
                if (Math.abs(value) >= 1000000000) {
                    return (value / 1000000000).toFixed(1) + 'B';
                } else if (Math.abs(value) >= 1000000) {
                    return (value / 1000000).toFixed(1) + 'M';
                } else {
                    return value;
                }
            }
        }
        
        
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                style: {
                    color: '#333', 
                    fontSize: '10px' ,
                },
                formatter: function() :string{
                    let value = (this as any).y;
                    if (Math.abs(value) >= 1000000000) {
                        return (value / 1000000000).toFixed(1) + 'B';
                    } else if (Math.abs(value) >= 1000000) {
                        return (value / 1000000).toFixed(1) + 'M';
                    } else {
                        return value;
                    }
                }
                
            },
        }
    },
    
    series: []
};

export const donutChartConfig = {
  chart: {
      type: 'pie',
      accessibility: {
        enabled: false
      }
  },
  title: {
      text: (null as any)
  },
  credits: {
      enabled: false
  },
  noData: {
      style: {
          fontWeight: 'bold',
          fontSize: '15px',
          color: '#ff0000'
      }
  },
  xAxis: {
      visible: true
  },
  yAxis: {
      visible: true
  },
  legend: {
      enabled: true, 
      align: 'center',
      verticalAlign: 'bottom',
  },
  plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: false,
              format: '<b>{point.name}</b>: {point.y}',
              style: {
                  color: (Highcharts.theme) || 'black'
              }
          },
          showInLegend: true,
          innerSize: '50%' // Set the innerSize to create the donut effect
      }
  },
  series: []
};

export const barChartData = {
    chart: {
      type: 'column',
      oneToOne: true,
      accessibility: {
        enabled: false
      }
    },
    title: {
      text: 'Example Chart'
    },
    xAxis: {
      categories: ['a','b','c'],
      title: {
        text: 'X-Axis'
      }
    },
    yAxis: {
      title: {
        text: 'Y-Axis'
      }
    },
    series: [{
      name: 'Label-1',
      data: [12,23,42],
      tooltip: {
        valueSuffix: 'years'
      }
    }, {
      name: 'Label-2',
      data: [10,20,40],
      tooltip: {
        valuePrefix: '$'
      },
    }],
    credits: {
      enabled: false
    },
    plotOptions: {
        column: {
            colorByPoint: true,
            dataLabels: {
                enabled: true
                
            }
      }
    }
};

export const lineChartData = {
    chart: {
      type: 'line',
      accessibility: {
        enabled: false
      }
    },
    title: {
      text: 'Example Chart'
    },
    xAxis: {
      categories: ['a', 'b', 'c'],
      title: {
        text: 'X-Axis'
      }
    },
    yAxis: {
      title: {
        text: 'Y-Axis'
      }
    },
    series: [{
      name: 'Label-1',
      data: [12,23,42],
      tooltip: {
        valueSuffix: 'years'
        },
        dataLabels: {
            enabled: true,
            align: 'center', 
            verticalAlign: 'bottom'
      }
    }, {
      name: 'Label-2',
      data: [10,20,40],
      tooltip: {
        valuePrefix: '$'
      },
        dataLabels: {
            enabled: true,
            align: 'center', 
            verticalAlign: 'top' 
        }
    }],
    credits: {
      enabled: false
    },
    plotOptions: {
      bar: {
        colorByPoint: true
      }
    }
};

export const pieChartData = {
  chart: {
      type: 'pie',
      accessibility: {
        enabled: false
      }
  },
  title: {
      text: 'Example Chart'
  },
  xAxis: {
      visible: true
  },
  yAxis: {
      visible: true
  },
  legend: {
    enabled: true, 
    align: 'center',
    verticalAlign: 'bottom',
  },
  plotOptions: {
    pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
            enabled: false,
            format: '<b>{point.name}</b>: {point.y}',
            style: {
                color: (Highcharts.theme) || 'black'
            }
        },
        showInLegend: true,
    }
  },
  series: [{
      name: 'Department',
      colorByPoint: true,
      data: [
          {
              name: 'Label-1',
              y: 130
          },
          {
              name: 'Label-2',
              y: 20
          },
          {
              name: 'Label-3',
              y: 15
          },
          {
              name: 'Label-4',
              y: 10
          },
          {
              name: 'Label-5',
              y: 35
          }
      ],
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      }
  }],
  credits: {
      enabled: false
  }
};

export const donutChartData = {
  chart: {
      type: 'pie',
      accessibility: {
        enabled: false
      }
  },
  title: {
      text: 'Example Chart'
  },
  xAxis: {
      visible: true
  },
  yAxis: {
      visible: true
  },
  legend: {
    enabled: true, 
    align: 'center',
    verticalAlign: 'bottom',
  },
  plotOptions: {
    pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
            enabled: false,
            format: '<b>{point.name}</b>: {point.y}',
            style: {
                color: (Highcharts.theme) || 'black'
            }
        },
        showInLegend: true,
        innerSize: '50%', 
    }
  },
  series: [{
      name: 'Department',
      colorByPoint: true,
      data: [
          {
              name: 'Label-1',
              y: 130
          },
          {
              name: 'Label-2',
              y: 20
          },
          {
              name: 'Label-3',
              y: 15
          },
          {
              name: 'Label-4',
              y: 10
          },
          {
              name: 'Label-5',
              y: 35
          }
      ],
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      }
  }],
  credits: {
      enabled: false
  }
};

export const stackBarChartData = {
    credits: {
        enabled: false
    },
    chart: {
        type: 'column',
        fixedPlacement: true,
        accessibility: {
            enabled: true
        }
    },
    title: {
        text: 'Example Chart'
    },
    xAxis: {
        title: {
            text: 'X-Axis'
        },
        categories: ['a', 'b', 'c', 'd']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Y-Axis'
        },
        stackLabels: {
            enabled: true
        }
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
            dataLabels: {
                enabled: true,
            }
        }
    },
    series: [{
        name: 'a',
        data: [3, 5, 1, 13]
    }, {
        name: 'b',
        data: [14, 8, 8, 12]
    }, {
        name: 'c',
        data: [5, 2, 6, 3]
    }]
};



export const fixedBarChartConfig = {
    credits: {
        enabled: false
    },
    chart: {
        type: 'column',
        spacing: [0, 0, 0, 0]
    },
    title: {
        text: 'Example Chart'
    },
    xAxis: {
        categories: [
            'Seattle HQ',
            'San Francisco',
            'Tokyo'
        ]
    },
    yAxis: [{
        title: {
            text: 'Employees'
        }
    }, {
        title: {
            text: 'Profit (millions)'
        },
        opposite: true
    }],
    legend: {
        shadow: false
    },
    tooltip: {
        shared: true
    },
    plotOptions: {
        column: {
            grouping: false,
            shadow: false,
            borderWidth: 0,
            // pointwidth : 8
        }
    },
    series: [{
        name: 'Employees',
        color: 'rgba(165,170,217,1)',
        data: [150, 73, 20],
        pointPadding: 0.3,
        pointPlacement: -0.2
    }, {
        name: 'Employees Optimized',
        color: 'rgba(126,86,134,.9)',
        data: [140, 90, 40],
        pointPadding: 0.4,
        pointPlacement: -0.2
    }, {
        name: 'Profit',
        color: 'rgba(248,161,63,1)',
        data: [183.6, 178.8, 198.5],
        pointPadding: 0.3,
        pointPlacement: 0.2,
        yAxis: 1
    }, {
        name: 'Profit Optimized',
        color: 'rgba(186,60,61,.9)',
        data: [203.6, 198.8, 208.5],
        pointPadding: 0.4,
        pointPlacement: 0.2,
        yAxis: 1
    }]
};



export type WidgetType = 'barChart' | 'lineChart' | 'pieChart' | 'donutChart' | 'stackBarChart' | 'fixedBarChart';

export const widgetType_Chart_Mapping: { [key in WidgetType]: any } = {
    barChart: barChartConfig,
    lineChart: lineChartConfig,
    pieChart: pieChartConfig,
    donutChart: donutChartConfig,
    stackBarChart: stackBarChartConfig,
    fixedBarChart : fixedBarChartConfig
}

export const widgetType_Data_Mapping: { [key in WidgetType]: any } = {
    barChart: barChartData,
    lineChart: lineChartData,
    pieChart: pieChartData,
    donutChart:donutChartData,
    stackBarChart: stackBarChartData,
    fixedBarChart : fixedBarChartConfig

}

export const chartTypes ={
  barChart: 'barChart',
  lineChart: 'lineChart',
  pieChart: 'pieChart',
  donutChart:'donutChart',
  stackBarChart: 'stackBarChart',
  fixedBarChart : 'fixedBarChart'
}

export const CHARTS_LEGEND_ALIGNMENT_MAPPING: { key: string, value: number,legendOption:any }[] = [
    { key: 'Top-Left', value: 0,legendOption:{align: 'left',
    verticalAlign: 'top',} },
    { key: 'Top-Center', value: 1 ,legendOption:{align: 'center',
    verticalAlign: 'top',}},
    { key: 'Top-Right', value: 2,legendOption:{align: 'right',
    verticalAlign: 'top',}},
    { key: 'Bottom-Left', value: 3,legendOption:{align: 'left',
    verticalAlign: 'bottom',} },
    { key: 'Bottom-Center', value: 4 ,legendOption:{align: 'center',
    verticalAlign: 'bottom',}},
    { key: 'Bottom-Right', value: 5,legendOption:{align: 'right',
    verticalAlign: 'bottom',}}
  ];